import dataLayerForSyte from '~/assets/services/dataLayer/dataLayerForSyte';
import SYTE_CONFIG from '~/src/config/syteSearch';

export default function () {
    window[SYTE_CONFIG.EVENTS_KEY] = Object.entries(dataLayerForSyte)
        .map(([syteEventName, syteEventCallback]) => ({ name: syteEventName, callback: syteEventCallback }));
}
